import { Spin } from "antd5";

export default function LoadingPage() {
  return <Spin fullscreen size="large" />;
}
